import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import { store } from "./store";
import Home from "./components/ExhibitorList";
import DetailPage from "./components/ExhibitorProfile/ExhibitorProfile";

Vue.config.productionTip = false;
Vue.use(VueRouter);

const routes = [
  {
    name: "home",
    path: "/conferences/2026-energy-influencers-program/",
    component: Home
  },
  {
    name: "SpeakerDetail",
    path: "/speakerdetail",
    component: DetailPage
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");
